'use client';

import { useState } from 'react';
import { CheckedState } from '@radix-ui/react-checkbox';
import { Button, Checkbox } from '@/shared/ui/core';
import { DEFAULT_COOKIE_CONSENT } from '../config/cookie-consent.config';
import { CookieConsent, OptionalCookieCategory } from '../model/cookie-consent.types';
import { useCookieConsent } from '../model/use-cookie-consent';
import { useCookieConsentStore } from '../model/cookie-consent.store';
import styles from './cookie-consent.module.scss';


export function CookieConsentSettings () {
    const { consent, saveConsent } = useCookieConsent();
    const setView                  = useCookieConsentStore((state) => state.setView);
    const close                    = useCookieConsentStore((state) => state.close);

    const [ form, setForm ] = useState<CookieConsent>(
        consent ?? DEFAULT_COOKIE_CONSENT,
    );

    function toggle (category: OptionalCookieCategory) {
        return (checked: CheckedState): void => {
            setForm((prev) => ({ ...prev, [category]: checked === true }));
        };
    }

    async function submit (): Promise<void> {
        await saveConsent(form);
        close();
    }

    return (
        <div>
            <div className={ styles.labels }>
                <Checkbox
                    checked
                    disabled
                    label='Necessary'
                />

                <Checkbox
                    label='Analytics'
                    checked={ form.analytics }
                    onCheckedChange={ toggle('analytics') }
                />
            </div>

            <div className={ styles.controls }>
                <Button
                    variant='primary'
                    onClick={ () => void submit() }
                >
                    Save settings
                </Button>

                <Button
                    variant='secondary'
                    onClick={ () => setView('banner') }
                >
                    Cancel
                </Button>
            </div>
        </div>
    );
}
